;(function(window, $) {
    window.ns = window.ns || {};
    window.$cache = window.$cache || {};

    window.ns['app'] = {
        init: function() {
            $.support.transition = false;

            // Main menu
            var menuItemHasDropdown = $('.header_nav_list > ul > li > a.item-with-submenu');
            menuItemHasDropdown.click(function () {
                if(window.innerWidth < 600 ||  window.innerWidth > 600 &&  window.innerWidth < 800){
                    $(this).parent().toggleClass('is-hover');
                }
            });

            // Scroll to top
            var scrollToTop = $('.scroll-to-top-btn');
            $(window).scroll(function(){
                window.scrollY > 100 ?
                    scrollToTop.show() :
                    scrollToTop.hide();
            });

            /*>>>>>>>>>>>>>>
            // scrolling plugin
            $('[data-scroll-target]').click(function(e){
                e.preventDefault();
                var targetName = $(this).data('scroll-target');
                var target = $('[data-scroll-id=' +targetName+']');
                if(target.length){
                    var px = target.offset().top;
                    var body = $("html, body");
                    body.stop().animate({scrollTop:target.offset().top}, '1000', 'swing', function() {
                        // console.log("Finished animating");
                    });
                }
            });
            */


            // Header history tablet
            var headerHistory = $('.header_history.link');
            headerHistory.click(function(){
                if( window.innerWidth > 600 &&  window.innerWidth < 800){
                    $(this).toggleClass('is-hover');
                }
            });

            // Search plugin
            $('.js-header_search').headerSearch();

            // Advanced search plugin
            //$('form.form_search-advanced').advancedSearch({});
            pageContext['components']['advancedSearch']['init'](pageContext['data']['search'] || {});

            // Client request modal
            $('.js-client-request-modal').clientRequestModal({});

            // Client request form
            $('form.js-client-feedback').clientRequest({});

            // My selection
            window.$cache['my-selection'] = $('.js-user-selection');
            $(document).on('plugins.my-selection', function(e, mySelectionCount) {
                if (mySelectionCount) {
                    window.$cache['my-selection'].removeClass('hidden');
                } else {
                    window.$cache['my-selection'].addClass('hidden');
                }
            });

            // adding class to vertical images
            var alignVerticalImg = function(els, className){
                $.each(els, function(){
                    if ($(this).height() >= $(this).width()) {
                        $(this).parent().addClass(className);
                    }
                })
            };
            $('img').load(function(){
                alignVerticalImg($('.list-offers .list-offers_item .offer-image img') ,'is-vertical');
            });
        }
    };
})(window, jQuery);
